<template>
  <div class="my-btn" :style="styleSheet">
    <el-button @click="$emit('click')" :loading="loading" :disabled="disabled" :style="`width:${width}`">
      <slot></slot>
    </el-button>
  </div>
</template>

<script>
export default {
  props: ["width", "loading",'disabled','styleSheet']
};
</script>

<style lang="scss" scoped>
.my-btn {
  .el-button {
    border-radius: 4px;
    border: 1px solid rgba(56, 186, 165, 1);
    font-size: 14px;
    font-weight: 400;
    color: rgba(22, 182, 149, 1);
    padding: 7px 30px;
  }
}
</style>